import { ROUTES } from '~/data/routes';
import { useMemo } from 'react';
import { useRouter } from 'next/router';

export const useCarOfTheYear = (carId: number) => {
  const router = useRouter();

  return useMemo(() => {
    const carOfTheYearIds = [234, 364];
    const carOfTheYearText = {
      [234]: {
        title: 'אוטו השנה של ישראל',
        subtitle: '',
      },
      [364]: {
        title: 'המנצחת בקטגוריית :',
        subtitle: 'משפחתית, קומפקטית וסדאן',
      },
    };

    const isNewCar =
      router.pathname.includes(ROUTES.CAR_PAGE) ||
      router.pathname.includes(ROUTES.RESULT_PAGE);
    const isCarOfTheYear = isNewCar && carOfTheYearIds.includes(carId);

    const carOfTheYearTextData =
      carOfTheYearText[carId as keyof typeof carOfTheYearText] || null;

    return { isCarOfTheYear, carOfTheYearText: carOfTheYearTextData };
  }, [router.pathname, carId]);
};
